import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { OrganisationMembership } from '../models';
import { organisationMembershipQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class OrganisationMembershipRepositoryService extends RepositoryService<OrganisationMembership> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, organisationMembershipQueries.selectAll);
  }
}
